const GIF_REGEX = /gif$/;
const SVG_REGEX = /svg/;

const isGif = (mimeType: string): boolean => GIF_REGEX.test(mimeType);
const isSVG = (mimeType: string): boolean => SVG_REGEX.test(mimeType);

export { isGif, isSVG };
